import { useStore } from 'vuex';
import useFetch from '../../../../composables/api/useFetch';
import fetchChart from './services/sizeChart.service';

export default function useSizeChart() {
  const store = useStore();
  const { hostlink } = store.state.envProps;

  return useFetch(fetchChart(hostlink));
}
